var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64582 0.147077C4.84073 -0.0485327 5.15731 -0.0490966 5.35292 0.145817L10.8374 5.6108C11.0531 5.82574 11.0531 6.17505 10.8374 6.39L5.35292 11.855C5.15731 12.0499 4.84073 12.0493 4.64582 11.8537C4.4509 11.6581 4.45147 11.3415 4.64708 11.1466L9.81166 6.0004L4.64708 0.854183C4.45147 0.659268 4.4509 0.342687 4.64582 0.147077ZM0.645817 0.147077C0.840731 -0.0485327 1.15731 -0.0490966 1.35292 0.145817L6.83741 5.6108C7.05312 5.82574 7.05312 6.17505 6.83741 6.39L1.35292 11.855C1.15731 12.0499 0.840731 12.0493 0.645817 11.8537C0.450903 11.6581 0.451467 11.3415 0.647077 11.1466L5.81166 6.0004L0.647077 0.854183C0.451467 0.659268 0.450903 0.342687 0.645817 0.147077Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.512719d9a503d3ec7d548bc81bf88384.svg";
export { ForwardRef as ReactComponent };